import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { get } from 'lodash';
import dateFormat from 'dateformat';
import { toast } from 'react-toastify';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { addLocale } from 'primereact/api';
import { Input155px, Input200px } from '../../../styles/inputGroup';
import Card from '../../../components/card';
import Loading from '../../loading';

import { displayErrors, formataMoeda } from '../../../util/diversos';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';

export default function RelatorioOsAparelho() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);
  const [findTipo, setFindTipo] = useState('TODAS');
  const [findSituacao, setFindSituacao] = useState('TODAS');
  const [findOficina, setFindOficina] = useState('TODAS');

  // eslint-disable-next-line no-unused-vars
  const [listaEmpresas, setListaEmpresas] = useState([]);

  const [listaOficina, setListaOficina] = useState([]);

  const [listaTipoOsAparelho] = useState([
    { label: 'Todas', value: 'TODAS' },
    { label: 'Serviço', value: 'SERVICO' },
    { label: 'Garantia', value: 'GARANTIA' },
    { label: 'Orçamento', value: 'ORCAMENTO' },
  ]);

  const [listaSituacaoOsAparelho] = useState([
    { label: 'Todas', value: 'TODAS' },
    { label: 'Aberta', value: 'ABERTA' },
    { label: 'Fechada', value: 'FECHADA' },
    { label: 'Cancelada', value: 'CANCELADA' },
  ]);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 99999,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });

  addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'hoje',
    clear: 'Limpar',
  });

  function headRows() {
    return [
      { numero: 'Número', dados: 'Dados', valorFinal: 'Valor Final' },
    ];
  }

  const [headerTabelaImpressao] = useState(headRows());

  const idUsuario = get(store.getState().auth.user, 'id', 0);

  async function getData(searchFilter, page, size, img) {
    // eslint-disable-next-line new-cap
    const doc = new jsPDF();
    try {
      setIsLoading(true);

      if (findDataInicial == null && findDataFinal == null) {
        toast.info('Datas devem ser informadas.');
        return;
      }

      if (findDataInicial > findDataFinal) {
        toast.info('Data final anterior a data inicial.');
        return;
      }

      let params = `/osaparelho/search?idUsuario=${idUsuario}`;

      if (searchFilter && searchFilter.findDataInicial !== '') {
        const _dataInicial = `${dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy')} 00:00:00`;
        const _dataFinal = `${dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy')} 23:59:59`;

        params = `${params}&dataInicial=${_dataInicial}&dataFinal=${_dataFinal}`;
      }

      if (searchFilter && searchFilter.findTipo !== 'TODAS') {
        params = `${params}&tipo=${searchFilter.findTipo}`;
      }

      if (searchFilter && searchFilter.findSituacao !== 'TODAS') {
        params = `${params}&situacao=${searchFilter.findSituacao}`;
      }

      if (searchFilter && searchFilter.findOficina !== 'TODAS') {
        params = `${params}&idOficina=${searchFilter.findOficina}`;
      }

      params = `${params}&page=${page}&size=${size}`;

      // console.log('params: ', params);

      const response = await axiosAdmin.get(params);

      if (response.data.content.length <= 0) {
        toast.info('Não há registros a serem exibidos.');
        return;
      }

      let data = {
        numero: '',
        dados: '',
        valorFinal: '',
      };

      const result = [];
      for (let x = 0; x < response.data.content.length; x++) {
        const osAparelho = response.data.content[x];

        data.numero = osAparelho.numero.toString();
        const dataOsAparelho = `${('00' + osAparelho.data[2]).slice(-2)}/${('00' + osAparelho.data[1]).slice(-2)}/${osAparelho.data[0]}`;
        data.dados += osAparelho.oficinaOperador.nome.padEnd(20) + ' ' + osAparelho.tipo.padEnd(18) + ' ' + osAparelho.situacao.padEnd(15);
        if (osAparelho.situacao === 'FECHADA') {
          data.dados += `Data Entrega: ${('00' + osAparelho.dataEntrega[2]).slice(-2)}/${('00' + osAparelho.dataEntrega[1]).slice(-2)}/${osAparelho.dataEntrega[0]}\n`;
        } else {
          data.dados += '\n';
        }
        data.dados += dataOsAparelho.padEnd(15) + ' ' + osAparelho.nomeCliente.substring(0, 33).padEnd(33) + ' ' + osAparelho.telefoneCliente;
        data.valorFinal = formataMoeda(osAparelho.valorFinal);

        result.push({ ...data });

        // let valorTotalItens = 0;
        for (let y = 0; y < osAparelho.listaOsAparelhoItem.length; y++) {
          const item = osAparelho.listaOsAparelhoItem[y];
          data.numero = '';
          data.dados = 'Item: ' + item.item.toString().padEnd(5)
                       + 'Cód: ' + item.produto.registro.toString().padEnd(5)
                       + ' ' + item.produto.descricao.substring(0, 43).padEnd(43)
                       + ' Qtde: ' + item.quantidade.toString().padEnd(5)
                       + ' UN: ' + formataMoeda(item.valorUnitario);
          data.valorFinal = ''; // formataMoeda(+item.quantidade * +item.valorUnitario);
          // valorTotalItens = +valorTotalItens + (+item.quantidade * +item.valorUnitario);
          result.push({ ...data });
        }

        data = {
          numero: '',
          dados: '',
          valorFinal: '',
        };
        result.push({ ...data });
      }

      // Header
      doc.rect(5, 5, 200, 30);
      doc.addImage(img, 'JPEG', 9, 8, 25, 25);
      doc.setFontSize(20);
      doc.text('Ordem de Serviço Aparelho ', 70, 15);

      doc.setFontSize(8);
      doc.text('Tipo:', 50, 22);
      doc.text(findTipo, 63, 22);

      doc.setFontSize(8);
      doc.text('Situação:', 50, 27);
      doc.text(findSituacao, 63, 27);

      doc.setFontSize(8);
      doc.text('Período:', 50, 32);
      doc.text(dateFormat(findDataInicial, 'dd/mm/yyyy'), 63, 32);
      doc.text(' à ', 79, 32);
      doc.text(dateFormat(findDataFinal, 'dd/mm/yyyy'), 83, 32);

      // colocar a empresa destino se houver

      doc.autoTable({
        styles: { fontSize: 8, font: 'Courier' },
        margin: { top: 38, left: 5, right: 5 },
        columnStyles: {
          2: { cellWidth: 25 },
        },
        theme: 'grid',
        head: headerTabelaImpressao,
        body: result,
        didDrawPage: dados => {
          // footer
          const { pageSize } = doc.internal;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(`Pag ${doc.internal.getNumberOfPages()}`, dados.settings.margin.right, pageHeight - 8);
          doc.text('Elo Informática Barbacena LTDA', 82, pageHeight - 8);
          const periodo = new Date();
          doc.text('Impresso: ', 172, pageHeight - 8);
          // eslint-disable-next-line prefer-template
          doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + (+periodo.getMonth() + 1)).slice(-2)}/${periodo.getFullYear()}`).toString(), 189, pageHeight - 8);
        },
      });
      window.open(doc.output('bloburl'));
    } catch (e) {
      // console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    setFindDataInicial(new Date(store.getState().auth.consultaEstampariaPedidoDataInicial));
    setFindDataFinal(new Date(store.getState().auth.consultaEstampariaPedidoDataFinal));
  }, []);

  useEffect(() => {
    async function verificarSeMultiEmpresa() {
      try {
        setIsLoading(true);

        const params = `/usuario/${idUsuario}`;

        const response = await axiosAdmin.get(params);

        const _listaEmpresas = get(response.data, 'listaEmpresas', []);

        const listDropdown = [{
          label: 'Todos',
          value: 'TODOS',
          id: 0,
        }];

        _listaEmpresas.forEach(element => {
          listDropdown.push(
            {
              label: element.razaoSocial,
              value: element.cnpj,
              id: element.id,
            });
        });

        listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

        setListaEmpresas(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    verificarSeMultiEmpresa();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function getOficina() {
      try {
        setIsLoading(true);

        const listDropdown = [{ label: 'Todas', value: 'TODAS' }];
        const { data: _oficina } = await axiosAdmin.get(`/oficina?idUsuario=${idUsuario}`);

        _oficina.forEach(element => {
          listDropdown.push({ label: `${element.nome}`, value: element.id });
        });

        setListaOficina(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getOficina();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal, findTipo, findOficina, findSituacao };

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    const loadImage = async () => {
      let config = '';
      try {
        config = await axiosAdmin.get(`/configuracaosistema?idUsuario=${idUsuario}`);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      }

      const img = new Image();
      img.src = `/logotipos/${config.data.urlLogotipo}`;

      await img.decode().then(() => {
      }).catch(() => {
        img.src = 'logo.png';
      });
      getData(searchFilter, 0, lazyParams.rows, img);
    };
    loadImage();
    // getData(searchFilter, 0, lazyParams.rows);
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}> Relatório de Ordem de Serviço Aparelho </h6>
        </div>

        <div className="row form-elo">
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data inicial
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataInicial}
                onChange={(e) => setFindDataInicial(e.value)}
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data final
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                mask="99/99/9999"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={findDataFinal}
                onChange={(e) => setFindDataFinal(e.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Tipo
              </Input155px>
              <Dropdown
                options={listaTipoOsAparelho}
                value={findTipo}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setFindTipo(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Situação
              </Input155px>
              <Dropdown
                options={listaSituacaoOsAparelho}
                value={findSituacao}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setFindSituacao(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon" title="Para operador de ordem de serviço">
                Oficina
              </Input200px>
              <Dropdown
                options={listaOficina}
                value={findOficina}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={e => setFindOficina(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-1">
            <button
              type="button"
              title="Imprimir Relatório"
              className="btn btn-success"
              style={{ borderRadius: '15px' }}
              onClick={handleFind}
            >
              <i className="pi pi-print"></i>
            </button>
          </div>
        </div>
      </Card>
    </>
  );
}
